import { GridMark } from "@/app/components/GridMark"

export function Logo() {
  return (
    <div className="flex items-center gap-3.5">
      <GridMark size={36} />
      <div className="flex flex-col">
        <div
          className="flex items-baseline"
          style={{
            fontFamily: "'DM Sans', sans-serif",
            fontSize: "22px",
            letterSpacing: "-0.01em",
            lineHeight: 1,
          }}
        >
          <span style={{ color: "rgba(255,255,255,0.9)", fontWeight: 300 }}>Land</span>
          <span style={{ color: "#3B9B63", fontWeight: 700 }}>Track</span>
        </div>
        <div
          style={{
            fontFamily: "'DM Sans', sans-serif",
            fontSize: "9px",
            fontWeight: 500,
            letterSpacing: "0.18em",
            textTransform: "uppercase",
            color: "rgba(255,255,255,0.28)",
            marginTop: "4px",
          }}
        >
          by Sowle Ventures
        </div>
      </div>
    </div>
  )
}
